import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { useLocation } from 'react-router-dom';
import packageInfo from '../../../package.json';

const Footer = (props) => {
  const location = useLocation();

  return (
    <React.Fragment>
      {location.pathname !== '/calls/manage' && (
        <footer className="footer">
          <Container fluid={true}>
            <Row>
              {/* One line on phones too: the footer has a fixed height */}
              <Col md={6} className="text-center text-md-left">
                {new Date().getFullYear()} © Chiedimi.it -{' '}
                <a
                  href="https://www.iubenda.com/privacy-policy/45512371/legal"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Privacy
                  <span className="d-none d-sm-inline"> Policy</span>
                </a>{' '}
                and{' '}
                <a
                  href="https://www.iubenda.com/privacy-policy/45512371/cookie-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Cookie
                  <span className="d-none d-sm-inline"> Policy</span>
                </a>
              </Col>
              <Col md={6}>
                <div className="text-md-right d-none d-md-block">
                  Design & Develop with{' '}
                  <i className="mdi mdi-heart text-danger"></i> by Chiedimi.it -
                  v{packageInfo.version}
                </div>
              </Col>
            </Row>
          </Container>
        </footer>
      )}
    </React.Fragment>
  );
};

export default Footer;
